import styled from 'styled-components'

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
}))

export const Table = styled.div(({ theme }) => ({
  border: `${theme.border.size['1']} solid ${theme.colors.gray200}`,
  borderRadius: theme.border.radius['6'],
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}))

export const Row = styled.div(({ theme }) => ({
  '&:nth-child(even)': {
    backgroundColor: theme.colors.gray200,
  },
  '&:nth-child(odd)': {
    backgroundColor: theme.colors.white,
  },
  alignItems: 'center',
  color: theme.colors.black600,
  display: 'flex',
  fontSize: '1.4rem',
  fontWeight: 500,
  justifyContent: 'space-between',
  lineHeight: '2rem',
  padding: `${theme.space['8']} ${theme.space['16']}`,
}))

export const AddSection = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
  marginBottom: theme.space['28'],
}))

export const AddRow = styled.div(({ theme }) => ({
  alignItems: 'flex-start',
  display: 'flex',
  gap: theme.space['16'],
}))
